import { useEffect } from 'react';

import loadTextStyleFontOperation from 'editor/src/store/design/operation/loadTextStyleFontOperation';
import { TextStyle } from 'editor/src/store/design/types';
import { useDispatch } from 'editor/src/store/hooks';

/**
 * GAPI-61895: loads the fonts of the styles shown as previews, so a style whose texts are on a
 * spread not shown yet still previews in its own font. Already-loaded fonts cost nothing.
 */
function useLoadTextStyleFonts(textStyles: TextStyle[]) {
  const dispatch = useDispatch();
  const fonts = [...new Set(textStyles.map((style) => style.fontFamily))].join('\n');
  useEffect(() => {
    fonts
      .split('\n')
      .filter(Boolean)
      .forEach((fontFamily) => void dispatch(loadTextStyleFontOperation(fontFamily)));
  }, [fonts]);
}

export default useLoadTextStyleFonts;
